import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, SimpleChange, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from '@angular/forms';
import { LanguagesService } from 'src/app/services/language.service';
import { BaseService } from 'src/app/services/base.service';
import { IsraelyStatusComponent } from './israely-status.component';

  @Component({
    selector: 'children-data',
    templateUrl: './children-data.component.html'
  })
  export class ChildrenDataComponent implements OnInit {
    @Input() form: FormGroup = null;
    @Input() numberOfChildren = 0;
    @Output() onreset = new EventEmitter();
    @Output() activateMe = new EventEmitter();
    @Output() nextTab = new EventEmitter<any>();
   isIsraely= false;
    isSubmited = false;
    childrenItems: FormArray;
    isSocialID_Mandarory = new Array<boolean>();
    @ViewChild(IsraelyStatusComponent) private israelyStatusComponent: IsraelyStatusComponent;

    constructor (public languagesService: LanguagesService,
        public baseService: BaseService,
        private formBuilder: FormBuilder) 
    { }

    ngOnInit(): void {
      this.form.addControl('childrenItems', this.formBuilder.array([]));        
      this.childrenItems = this.form.get('childrenItems') as FormArray;
    }

    ngOnChanges(changes: SimpleChanges) {
      const num: SimpleChange = changes.numberOfChildren;
      
      if (num)
        this.createFormControls();
    }

    createFormControls() {      
      const arr = this.childrenItems;
        while (arr && arr.length !== 0) {
            arr.removeAt(0)
          }

      for (let i=0; i < this.numberOfChildren; i++) {
        this.childrenItems.push (this.createChildItem());
      }
    }

    createChildItem() {
      return this.formBuilder.group({
            borne_israel : new FormControl(null, [Validators.required]),
            moia_donation : new FormControl(null, [Validators.required]),
            returning_donation : new FormControl(null, [Validators.required])
        });
    }    
child = "3";
    public get f() {
        return this.form.controls;  
    }

    public get f2() {
        return this.childrenItems.controls;  
    }

    onReset() {
        this.createFormControls();
        this.israelyStatusComponent.onReset();
        this.onreset.emit();
    }

    childrenItemValidation (idx) {
      let childForm = this.childrenItems.controls[idx] as FormGroup;
      let isValid = this.baseService.isFormDatesValid(childForm, 3);
      return isValid;  
    }

    isValid() {
      let isValid = true;
      for (let i=0; i<this.childrenItems.length; i++)
      {
        isValid = this.childrenItemValidation(i) && isValid;
      }
      isValid = isValid && !this.baseService.isExistsSocialID_DuplicationsMessage(this.form.parent, true);
      if (!isValid)
        this.activateMe.emit();
        
      return isValid;
    }

    onSubmit() {
      if (!this.isValid()) {
        return false;
      }

      this.isSubmited = true;
      return true;
    }

    checkIsraelyStatus(event, idx) {
      this.isSocialID_Mandarory[idx] = (event == 1);
    }
  }